<template>
  <div class="row">
    <div class="span8 list-main">
      <h1 class="list-title">有关 <span style="color: #0891B2;">{{ search }}</span> 的搜素结果</h1>

      <img v-if="empty" :src="$img.noinfo" style="width: 100%;" />
      <p v-if="empty" style="text-align: center; color: #999; padding: 10px 0 30px;">没有找到有关 {{ search }} 的搜素结果</p>

      <div v-if="res.help.length" style="margin-top: 20px;">
        <h3 style="border-left: 4px solid #0E7490; padding-left: 10px; margin-bottom: 10px;">问答</h3>
        <ul class="articles">
          <li class="article-entry" v-for="item in res.help" :key="item.help_id">
            <h4 class="entry-title"><router-link :to="`/helpcontent/${item.help_id}`" v-html="item.titlewraper"></router-link></h4>
            <div class="entry-meta">
              <span>🕐 {{ item.createtime | dataFormat }}</span>
              <span>👁 55</span>
            </div>
          </li>
        </ul>
      </div>

      <div v-if="res.oldstuff.length" style="margin-top: 20px;">
        <h3 style="border-left: 4px solid #0E7490; padding-left: 10px; margin-bottom: 10px;">二手</h3>
        <div class="stuff-grid">
          <div class="stuff-card" v-for="item in res.oldstuff" :key="item.oldstuff_id" style="width: 33.33%;">
            <router-link :to="`/oldstuffcontent/${item.oldstuff_id}`" class="thumbnail">
              <img :src="item.oldstuff_img" />
              <div class="caption">
                <div class="price">￥{{ item.oldstuff_price }}</div>
                <div class="name" v-html="item.namewraper"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="res.activity.length" style="margin-top: 20px;">
        <h3 style="border-left: 4px solid #0E7490; padding-left: 10px; margin-bottom: 10px;">活动</h3>
        <ul class="articles">
          <li class="article-entry" v-for="item in res.activity" :key="item.activity_id">
            <h4 class="entry-title"><router-link :to="`/activitycontent/${item.activity_id}`" v-html="item.titlewraper"></router-link></h4>
            <div class="entry-meta">
              <span>🕐 {{ item.createtime | dataFormat }}</span>
              <span>📍 {{ item.activity_locale }}</span>
              <span>人数 {{ item.activity_num }}</span>
            </div>
          </li>
        </ul>
      </div>

      <div v-if="res.article.length" style="margin-top: 20px;">
        <h3 style="border-left: 4px solid #0E7490; padding-left: 10px; margin-bottom: 10px;">文章</h3>
        <div v-for="item in res.article" :key="item.article_id" class="news-item">
          <h2><router-link :to="`/newscontent/${item.article_id}`" v-html="item.titlewraper"></router-link></h2>
          <div class="meta">
            <span>🕐 {{ item.article_createtime | dataFormat }}</span>
            <span>作者：{{ item.nickname }}</span>
            <span>3 Comments</span>
          </div>
          <p v-html="item.introductionwraper"></p>
        </div>
      </div>

      <div v-if="res.job.length" style="margin-top: 20px;">
        <h3 style="border-left: 4px solid #0E7490; padding-left: 10px; margin-bottom: 10px;">招聘</h3>
        <ul class="articles">
          <li class="article-entry" v-for="item in res.job" :key="item.job_id" style="position: relative;">
            <h4 class="entry-title" style="padding-right: 120px;"><router-link :to="`/jobcontent/${item.job_id}`" v-html="item.namewraper"></router-link></h4>
            <div class="entry-meta">
              <span>🕐 {{ item.job_createtime | dataFormat }}</span>
              <span>🏢 {{ item.company_name }}</span>
            </div>
            <h4 style="position: absolute; right: 4px; top: 14px; color: #e60000;">{{ item.job_salary }}</h4>
          </li>
        </ul>
      </div>

      <div v-if="res.company.length" style="margin-top: 20px;">
        <h3 style="border-left: 4px solid #0E7490; padding-left: 10px; margin-bottom: 10px;">公司</h3>
        <ul class="articles">
          <li class="article-entry" v-for="item in res.company" :key="item.company_id">
            <h4 class="entry-title"><router-link :to="`/companycontent/${item.company_id}`" v-html="item.namewraper"></router-link></h4>
          </li>
        </ul>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <div class="widget">
        <h3>搜索功能</h3>
        <p style="font-size: 13px; color: #666; line-height: 1.8;">该功能会搜索含有关键字的所有信息，该模块只能进行简单的搜索</p>
      </div>
      <activity-widget />
      <job-widget />
    </div>
  </div>
</template>

<script>
import activityWidget from '@/components/activity.vue'
import jobWidget from '@/components/job.vue'
import { searchAll } from '@/api'

export default {
  name: 'Search',
  components: { activityWidget, jobWidget },
  data() {
    return {
      search: this.$route.query.search || '',
      res: { help: [], activity: [], job: [], company: [], article: [], oldstuff: [] }
    }
  },
  computed: {
    empty() {
      return !this.res.help.length && !this.res.activity.length && !this.res.job.length && !this.res.company.length && !this.res.article.length && !this.res.oldstuff.length
    }
  },
  watch: {
    '$route.query.search'(val) {
      this.search = val || ''
      this.searchlist()
    }
  },
  created() {
    this.searchlist()
  },
  methods: {
    wraperkeyword(text) {
      if (!text || !this.search) return text
      // 转义正则特殊字符，防止输入 ( [ * 等导致整页报错
      const kw = this.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const reg = new RegExp(kw, 'ig')
      return String(text).replace(reg, (v) => `<span style="color:#0891B2">${v}</span>`)
    },
    searchlist() {
      if (!this.search) return
      searchAll(this.search).then((res) => {
        const d = res.data || {}
        this.res = {
          help: (d.help || []).map((x) => ({ ...x, titlewraper: this.wraperkeyword(x.help_title) })),
          activity: (d.activity || []).map((x) => ({ ...x, titlewraper: this.wraperkeyword(x.activity_title) })),
          job: (d.job || []).map((x) => ({ ...x, namewraper: this.wraperkeyword(x.job_name) })),
          company: (d.company || []).map((x) => ({ ...x, namewraper: this.wraperkeyword(x.company_name) })),
          article: (d.article || []).map((x) => ({ ...x, titlewraper: this.wraperkeyword(x.article_title), introductionwraper: this.wraperkeyword(x.article_introduction) })),
          oldstuff: (d.oldstuff || []).map((x) => ({ ...x, namewraper: this.wraperkeyword(x.oldstuff_name) }))
        }
      })
    }
  }
}
</script>
